export const timeZones = [
  { key: "UTC", title: "(GMT+00:00) UTC" },
  { key: "Pacific/Midway", title: "(GMT-11:00) Midway Island, Samoa" },
  { key: "America/Adak", title: "(GMT-10:00) Hawaii-Aleutian" },
  { key: "Etc/GMT+10", title: "(GMT-10:00) Hawaii" },
  { key: "Pacific/Marquesas", title: "(GMT-09:30) Marquesas Islands" },
  { key: "America/Anchorage", title: "(GMT-09:00) Alaska" },
  {
    key: "America/Los_Angeles",
    title: "(GMT-08:00) Pacific Time (US & Canada)",
  },
  { key: "America/Tijuana", title: "(GMT-08:00) Tijuana, Baja California" },
  { key: "America/Denver", title: "(GMT-07:00) Mountain Time (US & Canada)" },
  {
    key: "America/Chihuahua",
    title: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
  },
  { key: "America/Phoenix", title: "(GMT-07:00) Arizona" },
  { key: "America/Chicago", title: "(GMT-06:00) Central Time (US & Canada)" },
  {
    key: "America/Mexico_City",
    title: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
  },
  { key: "America/Regina", title: "(GMT-06:00) Saskatchewan" },
  { key: "America/Bogota", title: "(GMT-05:00) Bogota, Lima, Quito" },
  { key: "America/New_York", title: "(GMT-05:00) Eastern Time (US & Canada)" },
  { key: "America/Indiana/Indianapolis", title: "(GMT-05:00) Indiana (East)" },
  { key: "America/Caracas", title: "(GMT-04:30) Caracas" },
  { key: "America/La_Paz", title: "(GMT-04:00) La Paz" },
  { key: "America/Halifax", title: "(GMT-04:00) Atlantic Time (Canada)" },
  { key: "America/Santiago", title: "(GMT-04:00) Santiago" },
  { key: "America/St_Johns", title: "(GMT-03:30) Newfoundland" },
  {
    key: "America/Argentina/Buenos_Aires",
    title: "(GMT-03:00) Buenos Aires, Georgetown",
  },
  { key: "America/Sao_Paulo", title: "(GMT-03:00) Brasilia" },
  { key: "Atlantic/South_Georgia", title: "(GMT-02:00) Mid-Atlantic" },
  { key: "Atlantic/Azores", title: "(GMT-01:00) Azores" },
  { key: "Europe/London", title: "(GMT+00:00) Greenwich Mean Time : London" },
  {
    key: "Europe/Berlin",
    title: "(GMT+01:00) Central European Time : Berlin, Rome, Paris",
  },
  {
    key: "Europe/Belgrade",
    title: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  { key: "Europe/Madrid", title: "(GMT+01:00) Madrid, Lisbon, Casablanca" },
  { key: "Africa/Algiers", title: "(GMT+01:00) West Central Africa" },
  { key: "Europe/Athens", title: "(GMT+02:00) Athens, Bucharest, Istanbul" },
  { key: "Europe/Bucharest", title: "(GMT+02:00) Bucharest" },
  { key: "Africa/Cairo", title: "(GMT+02:00) Cairo" },
  { key: "Africa/Harare", title: "(GMT+02:00) Harare, Pretoria" },
  { key: "Asia/Jerusalem", title: "(GMT+02:00) Jerusalem" },
  { key: "Europe/Minsk", title: "(GMT+03:00) Minsk" },
  { key: "Asia/Kuwait", title: "(GMT+03:00) Kuwait, Riyadh" },
  {
    key: "Europe/Moscow",
    title: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
  },
  { key: "Africa/Nairobi", title: "(GMT+03:00) Nairobi" },
  { key: "Asia/Baghdad", title: "(GMT+03:00) Baghdad" },
  { key: "Asia/Tehran", title: "(GMT+03:30) Tehran" },
  { key: "Asia/Dubai", title: "(GMT+04:00) Abu Dhabi, Muscat" },
  { key: "Asia/Baku", title: "(GMT+04:00) Baku" },
  { key: "Asia/Yerevan", title: "(GMT+04:00) Yerevan" },
  { key: "Asia/Kabul", title: "(GMT+04:30) Kabul" },
  { key: "Asia/Yekaterinburg", title: "(GMT+05:00) Yekaterinburg" },
  { key: "Asia/Tashkent", title: "(GMT+05:00) Tashkent" },
  { key: "Asia/Karachi", title: "(GMT+05:00) Islamabad, Karachi, Tashkent" },
  {
    key: "Asia/Kolkata",
    title: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  },
  { key: "Asia/Kathmandu", title: "(GMT+05:45) Kathmandu" },
  { key: "Asia/Dhaka", title: "(GMT+06:00) Astana, Dhaka" },
  { key: "Asia/Novosibirsk", title: "(GMT+06:00) Novosibirsk" },
  { key: "Asia/Rangoon", title: "(GMT+06:30) Yangon (Rangoon)" },
  { key: "Asia/Bangkok", title: "(GMT+07:00) Bangkok, Hanoi, Jakarta" },
  { key: "Asia/Krasnoyarsk", title: "(GMT+07:00) Krasnoyarsk" },
  {
    key: "Asia/Hong_Kong",
    title: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  },
  { key: "Asia/Irkutsk", title: "(GMT+08:00) Irkutsk, Ulaan Bataar" },
  { key: "Asia/Singapore", title: "(GMT+08:00) Kuala Lumpur, Singapore" },
  { key: "Australia/Perth", title: "(GMT+08:00) Perth" },
  { key: "Asia/Tokyo", title: "(GMT+09:00) Osaka, Sapporo, Tokyo" },
  { key: "Asia/Seoul", title: "(GMT+09:00) Seoul" },
  { key: "Asia/Yakutsk", title: "(GMT+09:00) Yakutsk" },
  { key: "Australia/Darwin", title: "(GMT+09:30) Darwin" },
  { key: "Australia/Adelaide", title: "(GMT+09:30) Adelaide" },
  { key: "Australia/Sydney", title: "(GMT+10:00) Sydney, Melbourne" },
  { key: "Australia/Brisbane", title: "(GMT+10:00) Brisbane" },
  { key: "Australia/Hobart", title: "(GMT+10:00) Hobart" },
  { key: "Asia/Vladivostok", title: "(GMT+10:00) Vladivostok" },
  { key: "Pacific/Guam", title: "(GMT+10:00) Guam, Port Moresby" },
  {
    key: "Asia/Magadan",
    title: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
  },
  { key: "Pacific/Fiji", title: "(GMT+12:00) Fiji, Kamchatka, Marshall Is." },
  { key: "Pacific/Auckland", title: "(GMT+12:00) Auckland, Wellington" },
  { key: "Pacific/Tongatapu", title: "(GMT+13:00) Nuku'alofa" },
];

export const timeFormats = [
  { key: "12h", title: "12 Hours (AM/PM)" },
  { key: "24h", title: "24 Hours" },
];

export const currencySymbols = [
  { key: "AED", title: "United Arab Emirates Dirham (د.إ)" },
  { key: "AFN", title: "Afghan Afghani (؋)" },
  { key: "ALL", title: "Albanian Lek (L)" },
  { key: "AMD", title: "Armenian Dram (֏)" },
  { key: "ANG", title: "Netherlands Antillean Guilder (ƒ)" },
  { key: "AOA", title: "Angolan Kwanza (Kz)" },
  { key: "ARS", title: "Argentine Peso ($)" },
  { key: "AUD", title: "Australian Dollar (A$)" },
  { key: "AWG", title: "Aruban Florin (ƒ)" },
  { key: "AZN", title: "Azerbaijani Manat (₼)" },
  { key: "BAM", title: "Bosnia-Herzegovina Convertible Mark (KM)" },
  { key: "BBD", title: "Barbadian Dollar (B$)" },
  { key: "BDT", title: "Bangladeshi Taka (৳)" },
  { key: "BGN", title: "Bulgarian Lev (лв)" },
  { key: "BHD", title: "Bahraini Dinar (ب.د)" },
  { key: "BIF", title: "Burundian Franc (FBu)" },
  { key: "BMD", title: "Bermudian Dollar ($)" },
  { key: "BND", title: "Brunei Dollar (B$)" },
  { key: "BOB", title: "Bolivian Boliviano (Bs.)" },
  { key: "BRL", title: "Brazilian Real (R$)" },
  { key: "BSD", title: "Bahamian Dollar ($)" },
  { key: "BTN", title: "Bhutanese Ngultrum (Nu.)" },
  { key: "BWP", title: "Botswana Pula (P)" },
  { key: "BYN", title: "Belarusian Ruble (Br)" },
  { key: "BZD", title: "Belize Dollar (BZ$)" },
  { key: "CAD", title: "Canadian Dollar (C$)" },
  { key: "CDF", title: "Congolese Franc (FC)" },
  { key: "CHF", title: "Swiss Franc (CHF)" },
  { key: "CLP", title: "Chilean Peso ($)" },
  { key: "CNY", title: "Chinese Yuan (¥)" },
  { key: "COP", title: "Colombian Peso ($)" },
  { key: "CRC", title: "Costa Rican Colón (₡)" },
  { key: "CUP", title: "Cuban Peso ($)" },
  { key: "CVE", title: "Cape Verdean Escudo ($)" },
  { key: "CZK", title: "Czech Koruna (Kč)" },
  { key: "DJF", title: "Djiboutian Franc (Fdj)" },
  { key: "DKK", title: "Danish Krone (kr)" },
  { key: "DOP", title: "Dominican Peso (RD$)" },
  { key: "DZD", title: "Algerian Dinar (دج)" },
  { key: "EGP", title: "Egyptian Pound (£)" },
  { key: "ERN", title: "Eritrean Nakfa (Nfk)" },
  { key: "ETB", title: "Ethiopian Birr (Br)" },
  { key: "EUR", title: "Euro (€)" },
  { key: "FJD", title: "Fijian Dollar (FJ$)" },
  { key: "FKP", title: "Falkland Islands Pound (£)" },
  { key: "GBP", title: "British Pound (£)" },
  { key: "GEL", title: "Georgian Lari (₾)" },
  { key: "GHS", title: "Ghanaian Cedi (GH₵)" },
  { key: "GIP", title: "Gibraltar Pound (£)" },
  { key: "GMD", title: "Gambian Dalasi (D)" },
  { key: "GNF", title: "Guinean Franc (FG)" },
  { key: "GTQ", title: "Guatemalan Quetzal (Q)" },
  { key: "GYD", title: "Guyanese Dollar ($)" },
  { key: "HKD", title: "Hong Kong Dollar (HK$)" },
  { key: "HNL", title: "Honduran Lempira (L)" },
  { key: "HRK", title: "Croatian Kuna (kn)" },
  { key: "HTG", title: "Haitian Gourde (G)" },
  { key: "HUF", title: "Hungarian Forint (Ft)" },
  { key: "IDR", title: "Indonesian Rupiah (Rp)" },
  { key: "ILS", title: "Israeli New Shekel (₪)" },
  { key: "INR", title: "Indian Rupee (₹)" },
  { key: "IQD", title: "Iraqi Dinar (ع.د)" },
  { key: "IRR", title: "Iranian Rial (﷼)" },
  { key: "ISK", title: "Icelandic Krona (kr)" },
  { key: "JMD", title: "Jamaican Dollar (J$)" },
  { key: "JOD", title: "Jordanian Dinar (JD)" },
  { key: "JPY", title: "Japanese Yen (¥)" },
  { key: "KES", title: "Kenyan Shilling (KSh)" },
  { key: "KGS", title: "Kyrgyzstani Som (лв)" },
  { key: "KHR", title: "Cambodian Riel (៛)" },
  { key: "KMF", title: "Comorian Franc (CF)" },
  { key: "KRW", title: "South Korean Won (₩)" },
  { key: "KWD", title: "Kuwaiti Dinar (KD)" },
  { key: "KYD", title: "Cayman Islands Dollar ($)" },
  { key: "KZT", title: "Kazakhstani Tenge (₸)" },
  { key: "LAK", title: "Lao Kip (₭)" },
  { key: "LBP", title: "Lebanese Pound (£)" },
  { key: "LKR", title: "Sri Lankan Rupee (Rs)" },
  { key: "LRD", title: "Liberian Dollar ($)" },
  { key: "LSL", title: "Lesotho Loti (L)" },
  { key: "LYD", title: "Libyan Dinar (LD)" },
  { key: "MAD", title: "Moroccan Dirham (د.م.)" },
  { key: "MDL", title: "Moldovan Leu (L)" },
  { key: "MGA", title: "Malagasy Ariary (Ar)" },
  { key: "MKD", title: "Macedonian Denar (ден)" },
  { key: "MMK", title: "Myanmar Kyat (Ks)" },
  { key: "MNT", title: "Mongolian Tugrik (₮)" },
  { key: "MOP", title: "Macanese Pataca (MOP$)" },
  { key: "MRU", title: "Mauritanian Ouguiya (UM)" },
  { key: "MUR", title: "Mauritian Rupee (Rs)" },
  { key: "MVR", title: "Maldivian Rufiyaa (Rf)" },
  { key: "MWK", title: "Malawian Kwacha (MK)" },
  { key: "MXN", title: "Mexican Peso ($)" },
  { key: "MYR", title: "Malaysian Ringgit (RM)" },
  { key: "MZN", title: "Mozambican Metical (MT)" },
  { key: "NAD", title: "Namibian Dollar ($)" },
  { key: "NGN", title: "Nigerian Naira (₦)" },
  { key: "NIO", title: "Nicaraguan Córdoba (C$)" },
  { key: "NOK", title: "Norwegian Krone (kr)" },
  { key: "NPR", title: "Nepalese Rupee (Rs)" },
  { key: "NZD", title: "New Zealand Dollar (NZ$)" },
  { key: "OMR", title: "Omani Rial (﷼)" },
  { key: "PAB", title: "Panamanian Balboa (B/.)" },
  { key: "PEN", title: "Peruvian Sol (S/.)" },
  { key: "PGK", title: "Papua New Guinean Kina (K)" },
  { key: "PHP", title: "Philippine Peso (₱)" },
  { key: "PKR", title: "Pakistani Rupee (₨)" },
  { key: "PLN", title: "Polish Zloty (zł)" },
  { key: "PYG", title: "Paraguayan Guarani (₲)" },
  { key: "QAR", title: "Qatari Riyal (﷼)" },
  { key: "RON", title: "Romanian Leu (lei)" },
  { key: "RSD", title: "Serbian Dinar (дин.)" },
  { key: "RUB", title: "Russian Ruble (₽)" },
  { key: "RWF", title: "Rwandan Franc (FRw)" },
  { key: "SAR", title: "Saudi Riyal (﷼)" },
  { key: "SBD", title: "Solomon Islands Dollar ($)" },
  { key: "SCR", title: "Seychellois Rupee (₨)" },
  { key: "SDG", title: "Sudanese Pound (£)" },
  { key: "SEK", title: "Swedish Krona (kr)" },
  { key: "SGD", title: "Singapore Dollar (S$)" },
  { key: "SHP", title: "Saint Helena Pound (£)" },
  { key: "SLL", title: "Sierra Leonean Leone (Le)" },
  { key: "SOS", title: "Somali Shilling (Sh.So.)" },
  { key: "SRD", title: "Surinamese Dollar ($)" },
  { key: "SSP", title: "South Sudanese Pound (£)" },
  { key: "STN", title: "São Tomé and Príncipe Dobra (Db)" },
  { key: "SVC", title: "Salvadoran Colón ($)" },
  { key: "SZL", title: "Swazi Lilangeni (L)" },
  { key: "THB", title: "Thai Baht (฿)" },
  { key: "TJS", title: "Tajikistani Somoni (ЅМ)" },
  { key: "TMT", title: "Turkmenistan Manat (m)" },
  { key: "TND", title: "Tunisian Dinar (د.ت)" },
  { key: "TOP", title: "Tongan Paʻanga (T$)" },
  { key: "TRY", title: "Turkish Lira (₺)" },
  { key: "TTD", title: "Trinidad and Tobago Dollar (TT$)" },
  { key: "TWD", title: "New Taiwan Dollar (NT$)" },
  { key: "TZS", title: "Tanzanian Shilling (TSh)" },
  { key: "UAH", title: "Ukrainian Hryvnia (₴)" },
  { key: "UGX", title: "Ugandan Shilling (USh)" },
  { key: "USD", title: "US Dollar ($)" },
  { key: "UYU", title: "Uruguayan Peso ($)" },
  { key: "UZS", title: "Uzbekistani Som (so'm)" },
  { key: "VES", title: "Venezuelan Bolívar (Bs.S)" },
  { key: "VND", title: "Vietnamese Dong (₫)" },
  { key: "VUV", title: "Vanuatu Vatu (VT)" },
  { key: "WST", title: "Samoan Tala (WS$)" },
  { key: "XAF", title: "CFA Franc BEAC (FCFA)" },
  { key: "XCD", title: "East Caribbean Dollar (EC$)" },
  { key: "XOF", title: "CFA Franc BCEAO (CFA)" },
  { key: "XPF", title: "CFP Franc (₣)" },
  { key: "YER", title: "Yemeni Rial (﷼)" },
  { key: "ZAR", title: "South African Rand (R)" },
  { key: "ZMW", title: "Zambian Kwacha (ZK)" },
  { key: "ZWL", title: "Zimbabwean Dollar (Z$)" },
];
